<template>
    <div class="book">
        <img class="book--bind" :src="getImage()"/>
    </div>
</template>

<script>

export default {
  name: 'Book',
  components: {
  },
  props: {
      image: String
  },
  methods: {
      getImage() {
          return process.env.BASE_URL + `books/${this.image}.png`;//require(`../assets/books/${this.image}.png`)
      }
  }
}
</script>

<style  lang="scss" scoped>
    .book {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
    }
    .book--bind {
        width: 100%;
       margin-bottom: 20px;
    }

</style>